import { consoleEvents, getLabelFromStorage } from '@pb/utils'

import OPTIMIZELY from 'constants/optimizely'
import { SHOW_NOTIFICATION_TIME } from 'features/checkout/constants'
import { editQuantityOfItem, fetchPaymentModes } from 'features/checkout/requests'
import { showNotification } from 'features/notifications/duck/actions'
import { setOrderTotals } from 'features/orderTotals/duck/actions'
import getErrorData from 'helpers/getErrorData'
import { trackOptimizelyEvent } from 'helpers/optimizely'
import { ThunkResult } from 'redux/types'
import checkoutSelectors from 'features/checkout/duck/selectors'

import {
  editItemQuantityFail,
  editItemQuantityStart,
  editItemQuantitySuccess,
  fetchContextSuccess,
  setError,
  setParcelToShowInProductDetails,
  setShouldShowProductsDetails,
} from '../actions'
import { normalizeContextPartial } from '../normalize'

export const operationEditItemQuantity =
  (
    variantCode: string,
    quantity: number,
    isLastItem?: boolean,
    isInModal: boolean = false,
  ): ThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    dispatch(editItemQuantityStart(variantCode))
    try {
      const paymentModeData = checkoutSelectors.getPaymentModesSettings(getState())
      const contextResponse = await editQuantityOfItem(variantCode, quantity)

      const { paymentModeList } = await fetchPaymentModes()
      if (contextResponse?.context) {
        contextResponse.context.payment.paymentModeList = paymentModeList.map((mode) => ({
          ...paymentModeData[mode.code],
          ...mode,
        }))
      }

      const normalizedContext = dispatch(normalizeContextPartial({ ...contextResponse.context }))

      dispatch(fetchContextSuccess(normalizedContext))
      dispatch(setOrderTotals(contextResponse?.context?.orderTotals))
      dispatch(editItemQuantitySuccess(variantCode))
      trackOptimizelyEvent(OPTIMIZELY.REMOVE_ITEM_CHECKOUT_EVENT)
      if (isInModal) {
        trackOptimizelyEvent(OPTIMIZELY.REMOVE_ITEM_CHECKOUT_MODAL_EVENT)
      }
      if (isLastItem) {
        dispatch(setShouldShowProductsDetails(false))
        dispatch(setParcelToShowInProductDetails(''))
      }
    } catch (error) {
      const { status, code: responseErrorCode } = getErrorData(error)
      dispatch(setError({ code: status, message: responseErrorCode }))
      dispatch(
        showNotification({
          content: getLabelFromStorage('checkout.error.proceed.generic'),
          type: 'error',
          timespan: SHOW_NOTIFICATION_TIME,
        }),
      )
      dispatch(editItemQuantityFail(variantCode))
      consoleEvents.error(
        `ERROR OCCURRED when trying to delete item with: status: ${status} code:${responseErrorCode}`,
      )
    }
  }
